// src/store/modules/i18n.js
import apiClient from '@/api/index';
import { setI18nLocale } from '@/api/i18n';
import { DEFAULT_LOCALE, resolvePreferredLocale } from '@/utils/locale';

const state = {
    locale: resolvePreferredLocale(),
    messages: {},
};

const mutations = {
    setLocale(state, { locale, messages }) {
        state.locale = locale;
        state.messages = { ...state.messages, [locale]: messages };
        localStorage.setItem('locale', locale);
    },
};

const actions = {
    applyLocale({ commit }, { locale, messages }) {
        setI18nLocale(locale, messages);
        commit('setLocale', { locale, messages });
        return messages;
    },
    async loadLocale({ dispatch }, locale = DEFAULT_LOCALE) {
        try {
            const response = await apiClient.get(
                `/languages/lang/${locale}?disable_cache=false`,
                { skipAuthorization: true }
            );
            return dispatch('applyLocale', {
                locale,
                messages: response.data,
            });
        } catch (error) {
            if (locale !== DEFAULT_LOCALE) {
                console.warn(
                    `Failed to load locale "${locale}", falling back to "${DEFAULT_LOCALE}".`
                );
                return dispatch('loadLocale', DEFAULT_LOCALE);
            }

            throw error;
        }
    },
    async ensureLocaleLoaded({ state, dispatch }, locale = state.locale) {
        if (state.messages[locale]) {
            return dispatch('applyLocale', {
                locale,
                messages: state.messages[locale],
            });
        }

        return dispatch('loadLocale', locale);
    },
};

const getters = {
    locale: state => state.locale,
    messages: state => state.messages,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
